import { createFeature, createReducer, on } from '@ngrx/store';

import { ProductBox } from 'app/shared/components/product-box/models';
import { updateProductBoxes } from 'app/state/product-boxes/product-box.actions';

export const productBoxFeatureKey = 'product-boxes';

export interface ProductBoxState {
    productBoxList: ProductBox[];
}

export const initialState: ProductBoxState = { productBoxList: [] };

export const reducer = createReducer(
    initialState,
    on(updateProductBoxes, (state, { productBoxList }) => {
        // Actions of type 'updateProductBoxes' are dispatched by master-data.service on a regular basis.
        // Here we check if the content for productBox list has changed. If not then the state does not change.
        // Otherwise, components consuming productBox list from the state will detect changes, and they will refresh
        // while it is not necessary. It will lead to unpredicted side effect. For example, the components
        // representing the productBox list will be destroyed and recreated again on every change of the state.
        const currentJson = JSON.stringify(sortProductBoxes(state.productBoxList));
        const newJson = JSON.stringify(sortProductBoxes(productBoxList));
        const listChanged = currentJson !== newJson;
        return listChanged
            ? {
                  ...state,
                  productBoxList: [...productBoxList],
              }
            : state;
    }),
);

export const productBoxFeature = createFeature({
    name: productBoxFeatureKey,
    reducer,
});

function sortProductBoxes(list: ProductBox[]) {
    return [...list].sort((a, b) => a.number - b.number);
}
